<template>
  <div class="flex flex-column border-1">
    <DataTable :value="flowResultRows">
      <Column header="raw">
        <template #body="slotProps">
          <Button @click="showRaw(slotProps.data)">Raw</Button>
        </template>
      </Column>
      <Column header="flowRate">
        <template #body="slotProps">{{
          slotProps.data.hypotheticalFlowRateSTBD
        }}</template>
      </Column>
      <Column header="produced">
        <template #body="slotProps">{{
          slotProps.data.producedPressurePSIA
        }}</template>
      </Column>
      <Column header="required">
        <template #body="slotProps">{{
          slotProps.data.requiredPressurePSIA
        }}</template>
      </Column>
      <Column header="pressureDifference">
        <template #body="slotProps">
          {{ slotProps.data.pressureDifference }}
        </template>
      </Column>
      <Column header="pressureDifferenceChange">
        <template #body="slotProps">
          {{ slotProps.data.pressureDifferenceChange }}
        </template>
      </Column>
      <Column field="isHealthy" header="isHealthy"></Column>
      <Column field="withinTolerance" header="withinTolerance"></Column>
      <Column field="depth" header="depth"></Column>
      <Column field="status" header="status"></Column>
    </DataTable>
  </div>
</template>

<script lang="ts" setup>
import type { HypotheticalFlowDataRow } from "@/libs/calculations/predictiveCalcs/getPredictedDesiredFlowRateSTBD";

defineProps<{
  flowResultRows: HypotheticalFlowDataRow[] | undefined;
}>();

const showRaw = (data: unknown) => {
  alert(JSON.stringify(data, null, 2));
};
</script>
